import { render, staticRenderFns } from "./WaiterFamilyRegister.vue?vue&type=template&id=de976794&scoped=true&lang=pug"
import script from "./WaiterFamilyRegister.vue?vue&type=script&lang=ts"
export * from "./WaiterFamilyRegister.vue?vue&type=script&lang=ts"
import style0 from "./WaiterFamilyRegister.vue?vue&type=style&index=0&id=de976794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de976794",
  null
  
)

export default component.exports